import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { setMeta } from '../utils/seo';

function Guide() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-in-out',
    });
      setMeta({
         title: 'HHpoker攻略｜德州扑克新手入门与实战技巧',
         description: '提供HHpoker新手入门、规则讲解、位置策略、筹码管理与复盘思路，帮助玩家从基础到实战逐步提升。',
         keywords: '德州扑克攻略, 德州扑克入门, 德州扑克技巧, 德州扑克位置策略, 德州扑克河牌决策, HHpoker攻略',
         url: window.location.origin + '/guide/',
         robots: 'index,follow',
         image: window.location.origin + '/images/art1.jpeg'
      });
  }, []);

  const guides = [
     {
        title: '竞技扑克新手入门规则',
        desc: '竞技扑克怎么玩？详细图解规则与基本操作流程。',
        date: '2025-10-20',
        image: '/images/art1.jpeg' 
     },
     {
        title: '奥马哈Omaha竞技详解',
        desc: '奥马哈与竞技扑克的区别，四张底牌的策略分析。',
        date: '2025-11-05',
        image: '/images/art2.jpeg'
     },
     {
        title: '进阶攻略：位置的重要性',
        desc: '为什么位置是竞技扑克中最最重要的概念之一？如何利用位置优势？',
        date: '2025-11-12',
        image: '/images/art3.png' 
     },
     {
        title: '积分管理：如何长期提升战绩',
        desc: '不管是常规桌还是比赛，良好的战绩管理是每一位竞技选手的必修课。',
        date: '2025-12-01',
        image: '/images/art4.jpeg'
     },
    {
        title: '竞技牛仔玩法介绍',
        desc: '全新的牛仔玩法，更刺激的竞技体验。',
        date: '2026-01-15',
        image: '/images/art5.jpeg'
     },
     {
        title: '如何识别和利用对手的马脚',
        desc: '观察对手的动作、决策时间和身体语言，捕捉每一个获利机会。',
        date: '2026-02-20',
        image: '/images/art6.jpeg'
     }
  ];

  return (
    <div style={{ background: '#1a1c29', color: '#fff', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
       
       <section className="hero-section guide-hero" style={{ 
          padding: '120px 8vw 80px', 
          background: `linear-gradient(rgba(20,22,34,0.8), rgba(20,22,34,0.9)), url('/images/banner.jpg') center/cover no-repeat fixed`, 
          textAlign: 'center' 
       }}>
          <h1 data-aos="fade-down" style={{ fontSize: '3.5rem', color: '#efa765', marginBottom: '20px', fontWeight: 800 }}>扑克进阶攻略</h1>
          <p data-aos="fade-up" style={{ fontSize: '1.2rem', color: '#e0e0e0', maxWidth: '700px', margin: '0 auto', lineHeight: 1.6 }}>
             从新手入门到职业进阶，这里有最全面的竞技扑克攻略和技巧分享。
          </p>
       </section>

       <section style={{ padding: '60px 8vw', background: '#1a1c29', flex: 1 }}>
               <div style={{ maxWidth: '1200px', margin: '0 auto 24px auto', background: '#202334', border: '1px solid #2a2d42', borderRadius: '12px', padding: '18px 20px' }}>
                  <h2 style={{ color: '#efa765', fontSize: '1.3rem', marginBottom: '10px' }}>新手教程快速问答</h2>
                  <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：德州扑克平台新手教程从哪里开始？</strong></p>
                  <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：建议先看入门规则与位置策略，再进入翻牌圈、转牌和河牌决策内容，学习路径更清晰。</p>
                  <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：新手先学哪些内容更实用？</strong></p>
                  <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：优先学习起手牌范围、位置优势和资金管理，这三项最能提升实战稳定性。</p>
                  <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：德州平台攻略内容更新怎么看是否有价值？</strong></p>
                  <p style={{ color: '#aeb4c2', marginBottom: '8px' }}>A：建议关注是否持续提供可执行的复盘步骤和场景拆解，而不是只做概念性描述。</p>
                  <p style={{ color: '#cfd3dc', marginBottom: '8px' }}><strong>Q：德扑平台进阶技巧栏目适合什么阶段看？</strong></p>
                  <p style={{ color: '#aeb4c2', marginBottom: '0' }}>A：当你已掌握基础规则后，可重点阅读进阶栏目中的位置博弈、范围构建和河牌决策内容。</p>
               </div>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', 
            gap: '30px', 
            maxWidth: '1200px', 
            margin: '0 auto' 
          }}>
             {guides.map((guide, index) => (
                <div key={index} data-aos="fade-up" data-aos-delay={index * 100} style={{
                   background: '#232533',
                   borderRadius: '12px',
                   overflow: 'hidden',
                   boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                   transition: 'transform 0.3s ease'
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                   <div style={{ height: '200px', overflow: 'hidden' }}>
                      <img src={guide.image} alt={guide.title} style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s ease' }} 
                      onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                      onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                      />
                   </div>
                   <div style={{ padding: '24px' }}>
                      <div style={{ fontSize: '0.85rem', color: '#efa765', marginBottom: '10px' }}>{guide.date}</div>
                      <h3 style={{ fontSize: '1.3rem', color: '#fff', marginBottom: '12px', lineHeight: 1.4 }}>{guide.title}</h3>
                      <p style={{ fontSize: '0.95rem', color: '#aaa', lineHeight: 1.6, marginBottom: '20px' }}>{guide.desc}</p>
                      
                                 <Link to={`/guide/detail?title=${encodeURIComponent(guide.title)}`} style={{
                                    display: 'inline-block',
                                    textDecoration: 'none',
                                    background: 'transparent',
                                    border: '1px solid #efa765',
                                    color: '#efa765',
                                    padding: '8px 20px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '0.9rem',
                                    transition: 'all 0.3s'
                                 }}
                                 onMouseOver={(e) => {
                                    e.currentTarget.style.background = '#efa765';
                                    e.currentTarget.style.color = '#1a1c29';
                                 }}
                                 onMouseOut={(e) => {
                                    e.currentTarget.style.background = 'transparent';
                                    e.currentTarget.style.color = '#efa765';
                                 }}
                                 >阅读全文</Link>
                   </div>
                </div>
             ))}
          </div>
       </section>

       <footer style={{ background: '#0c0909', padding: '40px 8vw', borderTop: '1px solid #222', textAlign: 'center' }}>
        <p style={{ color: '#555', fontSize: '0.9rem' }}>Copyright © 2026 HHpoker. All Rights Reserved.</p>
      </footer>

    </div>
  );
}

export default Guide;
